import { observable, action, reaction } from 'mobx';

class CommonStore {
  @observable token = localStorage.getItem('token');
  @observable isAppLoaded = false;
  @observable isSidebarActive = false;
  @observable sidebarSelectedKey = '';
  @observable currentRoute = null;

  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          localStorage.setItem('token', token);
        } else {
          localStorage.removeItem('token');
        }
      }
    );
  }

  @action
  setToken(token) {
    this.token = token;
  }

  @action
  setAppLoaded() {
    this.isAppLoaded = true;
  }

  @action
  toggleSidebar() {
    this.isSidebarActive = !this.isSidebarActive;
  }

  @action
  handleSidebarKeySelection(key) {
    this.sidebarSelectedKey = key;
  }

  @action
  setCurrentRoute(route) {
    this.currentRoute = route;
  }
}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/store/commonStore.js